import { gql } from 'graphql-request'
import { graphQLClient } from '@/core/config/graphqlClient'

const FETCH_INTERVIEW_EVENTS = gql`
  query interviewEvents(
    $interviewRequestId: ID
    $sortBy: InterviewEventSortBy
    $sortDirection: SortDirection
    $interviewSource: InterviewEventModel
    $eventsAfter: ISO8601DateTime
    $eventsBefore: ISO8601DateTime
    $period: InterviewEventPeriod
    $statuses: [InterviewEventStatus!]
  ) {
    interviewEvents(
      interviewRequestId: $interviewRequestId
      sortDirection: $sortDirection
      sortBy: $sortBy
      interviewSource: $interviewSource
      eventsAfter: $eventsAfter
      eventsBefore: $eventsBefore
      period: $period
      statuses: $statuses
    ) {
      nodes {
        id
        startAt
        endAt
        location
        category
        skypeHandleCandidate
        skypeHandleMember
        videoCallUrl
        phoneNumberCandidate
        poweredBy
        title
        status
        createdAt
        googleCalendarLink
        candidateProfile {
          name
        }
        memberProfile {
          name
          id
        }
      }
    }
  }
`

const CREATE_INTERVIEW_EVENT = gql`
  mutation createInterviewEvent($input: CreateInterviewEventInput!) {
    createInterviewEvent(input: $input) {
      interviewEvent {
        id
        startAt
        endAt
        location
        duration
        description
        category
        skypeHandleCandidate
        skypeHandleMember
        videoCallUrl
        phoneNumberCandidate
        status
        createdAt
        googleCalendarLink
        title
        poweredBy
        candidateProfile {
          name
        }
        memberProfile {
          name
          id
        }
      }
      errors {
        message
      }
    }
  }
`

export const fetchInterviewEvents = ({
  interviewRequestId,
  sortBy,
  sortDirection,
  interviewSource,
  statuses,
  period,
  eventsAfter,
  eventsBefore,
}) =>
  graphQLClient(FETCH_INTERVIEW_EVENTS, {
    interviewRequestId,
    sortBy,
    sortDirection,
    interviewSource,
    statuses,
    period,
    eventsAfter,
    eventsBefore,
  })

export const createInterviewEvent = ({ input }) => graphQLClient(CREATE_INTERVIEW_EVENT, { input })
